// Deprecated from default presets: publicly hosted VPAID test tags are unreliable
// (CORS, runtime and asset availability drift) and caused frequent false negatives.
// Keep this export for registry compatibility.
export const vpaidTags = [];
